<template>
  <div class="flex flex-col">
    <div class="card">
      <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <h4 class="header-title p-2">Listado de empresas</h4>
        <form @submit.prevent="fetch()" class="col-12">
          <div class="form-row row text-center">
            <div class="col-11">
              <b-form-input
                type="text"
                name="search"
                id="search"
                v-model="search"
                @update="fetch()"
                class="form-control px-2"
                placeholder="Buscar"
              ></b-form-input>
            </div>
            <div class="col-1">
              <button type="submit" class="btn btn-primary px-2">Buscar</button>
            </div>
          </div>
        </form>

        <div v-if="!loading">
          <table
            class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12"
          >
            <thead class="table-active">
              <tr>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Tipo de persona
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  NIT
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Nombre
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Nombre comercial
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Dirección
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Teléfono
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1"
                >
                  CIIU
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  ARL
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Representante Legal
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Correo electrónico
                </th>
                <th
                  scope="col"
                  class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1"
                >
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="company in companies" :key="company.id">
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.is_natural != 1 ? "Persona Jurídica" : "Persona Natural" }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  <div class="text-sm font-medium text-gray-700">
                    <b>{{ company.nit }}-{{ company.dv }}</b>
                  </div>
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.social_reason }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.commercial_name }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.address }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.phone }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  <div class="col-sm-12" v-if="company.arl_id">
                    <DisplayModal
                      :companyID="Number(company.uuid)"
                      :disabled="!allowAccess(company.uuid)"
                    />
                  </div>
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ getARL(company.arl_id) }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.legal_representative }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ company.legal_representative_email }}
                </td>
                <td class="text-center">
                  <div class="col-sm-12">
                    <b-dropdown
                      variant="primary"
                      dropleft
                      :disabled="!allowAccess(company.uuid)"
                    >
                      <template v-slot:button-content>
                        <i class="mdi mdi-eye"></i>
                      </template>
                      <b-dropdown-item
                        @click="selectCompany(company)"
                        :href="`/forms/editar-empresa/${company.uuid}`"
                      >
                        Editar
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="text-center pt-4">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <Pagination
          ref="paginator"
          @loading="(load) => (loading = load)"
          :search="search"
          link="https://sso.emision.co/api/v1/companies"
          @fetch="(items) => (companies = items)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "./Pagination";
import ArlAPI from "@/services/arl/arlAPI";
import CIIUAPI from "@/services/sso/ciiu/ciiuAPI";
import CompanyAPI from "@/services/company/companyAPI";
import DisplayModal from "./ciiu/DisplayModal";

export default {
  components: {
    Pagination,
    DisplayModal,
  },
  data() {
    return {
      companies: [],
      search: "",
      arlList: [],

      accessCompanies: [],

      loading: true,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    selectCompany(company) {
      this.companySelected = company;

      this.$store.dispatch("company/removeCompany");

      this.$store.dispatch("company/addCompany", company);
      this.$store.dispatch("notification/clear");
    },

    searchData() {
      // console.log(this.search);
    },

    getARLs() {
      ArlAPI.getAllARLs()
        .then((response) => {
          this.arlList = response.arl || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess(id) {
      const user = this.$store.state.auth;
      // console.log(user);

      const role = Number(user.info.role);

      // Roles internos (1,3,4,5) y roles asignados via SST (6,7,8): acceso
      // permitido. Para 6/7/8 la lista ya viene filtrada a sus empresas
      // asignadas, asi que toda fila visible es accesible.
      if ([1, 3, 4, 5, 6, 7, 8].includes(role)) {
        return true;
      }

      const access = this.accessCompanies.find((company) => company.uuid === id);

      return access ? true : false;
    },

    getCompanies() {
      const user = this.$store.state.auth;
      CompanyAPI.getCompanyByDesign(user.user.nodexum_id)
        .then((response) => {
          // console.log("Companies with sso user: ", response);

          this.accessCompanies = response.companies;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getARL(id) {
      if (id) return this.arlList.find((arl) => arl.id === id).name;
      else return "";
    },

    getCIIUs(id) {
      CIIUAPI.getByCompany(id)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getARLs();
    this.getCompanies();
  },
};
</script>

<style lang="scss" scoped></style>
